import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { DISLIKE_SETTING, DISLIKE_SETTING_MSB } from '@/graphql/mutations/customerFeedback';

import logger from '@/modules/Logger';

export const UpdateDislikeSettingService = {
  msb: async (variables, successCallback, errorCallback) => {
    logger.debug(`[CFE][UpdateDislikeSetting] Update dislike setting using MSB GraphQL endpoint`, {
      operation: 'cfe:update-dislike-setting'
    });

    await myStageApolloProvider.defaultClient
      .mutate({
        mutation: DISLIKE_SETTING_MSB,
        variables: variables
      })
      .then(successCallback)
      .catch((error) => {
        logger.error(`[CFE][UpdateDislikeSetting] Error on updating dislike setting using MSB GraphQL endpoint`, {
        operation: 'cfe:update-dislike-setting',
          error: error.message
        });
        errorCallback(error);
      });
  },
  
  mbti: async (variables, successCallback, errorCallback) => {
    logger.debug(`[CFE][UpdateDislikeSetting] Update dislike setting using MBTI GraphQL endpoint`, {
      operation: 'cfe:update-dislike-setting'
    });

    await apolloProvider.defaultClient
      .mutate({
        mutation: DISLIKE_SETTING,
        variables: variables
      })
      .then(successCallback)
      .catch((error) => {
        logger.error(`[CFE][UpdateDislikeSetting] Error on updating dislike setting using MBTI GraphQL endpoint`, {
        operation: 'cfe:update-dislike-setting',
          error: error.message
        });
        errorCallback(error);
      });
  }
};


// Route legacy endpoint to MBTI, because this API does not have FuelPHP version
UpdateDislikeSettingService.legacy = UpdateDislikeSettingService.mbti;
